module.exports = __webpack_public_path__ + "static/fb-image_en-12f39e7670d46e42258c01b7ffe1d444.png";